import React from "react";
import PropTypes from "prop-types";

// COMPONENTS
import StackLayout from "@components/layouts/StackLayout/StackLayout";
import {BankIdModal} from "@glofitech/react-lib";
// HELPERS
import {createClassName} from "@helpers/utils";
import Button from "../../../../../components/Button/Button";
import logoBankID from "@assets/img/logo_bankid.png";
import api from "../../../../../helpers/api";

export default class CobStart extends React.PureComponent
{
    static propTypes = {
        onLookupDataLoaded: PropTypes.func.isRequired
    };

    state = _getInitialState.call(this);

    toggleBankIdModal = () =>
    {
        this.setState({
            ...this.state,
            showBankIdModal: !this.state.showBankIdModal
        });
    };

    handleLogin = async authData =>
    {
        try
        {
            const verificationResult = await api("/bankid/verify", {
                identity_no: authData.personalNumber,
                token: authData.token
            });

            window.location = window.location.href + "?context=" + verificationResult.context;
        }
        catch (ex)
        {
            alert("Fel vid inloggning med BankID");
        }
    };

    render()
    {
        const {props} = this;
        const {app} = props;
        const {partner} = app;
        const classes = createClassName("Cob-Start", {});

        return (
            <div className={classes}>
                <StackLayout orientation="vertical" fullWidth>
                    <h1>{partner.welcomeTitle}</h1>

                    {partner.welcomeSubtitle && (
                        <h2>{partner.welcomeSubtitle}</h2>
                    )}

                    <img src={logoBankID} style={{height: "120px"}} alt="BankID" />

                    <Button 
                        onClick={this.toggleBankIdModal.bind(this)}
                        label="Legitimera"
                        appearance={"medium"}
                        accentColor={partner.accentColors.secondary}
                        style={{margin: "0"}}
                    />

                    <p className={"intro"}>
                        Logga in med BankID genom att klicka på knappen "Legitimera" ovan.
                    </p>
                    <BankIdModal
                        isOpen={this.state.showBankIdModal}
                        apiKey={partner.bankid.apiKey}
                        apiToken={partner.bankid.apiToken}
                        loginHandler={this.handleLogin}
                        toggleModal={this.toggleBankIdModal}
                        handleNavigateToStart={this.handleNavigateToStart}
                        supportEmail={"info@fairinvestments.se"}
                        urlPath={partner._name}
                        backendApiUrl={partner.bankid.environment}
                        collectIntervalMs={3000}
                    />
                </StackLayout>
            </div>
        );
    }
}

// PRIVATE FUNCTIONS
function _getInitialState()
{
    return {
        showBankIdModal: false,
        hidden: true,
        busy: false
    };
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Start/login/Start.js